/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Notification } from '../models';
// @ts-ignore
import type { ResponseCountNewNotifications } from '../models';
/**
 * NotificationMessagesApi - axios parameter creator
 * @export
 */
export const NotificationMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Count new notification messages
         * @param {CountNewNotificationMessagesCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countNewNotificationMessages: async (category: CountNewNotificationMessagesCategoryEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('countNewNotificationMessages', 'category', category)
            const localVarPath = `/admin/notification/messages/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all notification about messages
         * @param {MessagesNotificationCategoryEnum} category 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagesNotification: async (category: MessagesNotificationCategoryEnum, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('messagesNotification', 'category', category)
            const localVarPath = `/admin/notification/messages/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationMessagesApi - functional programming interface
 * @export
 */
export const NotificationMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Count new notification messages
         * @param {CountNewNotificationMessagesCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countNewNotificationMessages(category: CountNewNotificationMessagesCategoryEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCountNewNotifications>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countNewNotificationMessages(category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationMessagesApi.countNewNotificationMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all notification about messages
         * @param {MessagesNotificationCategoryEnum} category 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messagesNotification(category: MessagesNotificationCategoryEnum, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messagesNotification(category, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationMessagesApi.messagesNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationMessagesApi - factory interface
 * @export
 */
export const NotificationMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationMessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Count new notification messages
         * @param {CountNewNotificationMessagesCategoryEnum} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countNewNotificationMessages(category: CountNewNotificationMessagesCategoryEnum, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCountNewNotifications> {
            return localVarFp.countNewNotificationMessages(category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all notification about messages
         * @param {MessagesNotificationCategoryEnum} category 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messagesNotification(category: MessagesNotificationCategoryEnum, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Notification>> {
            return localVarFp.messagesNotification(category, filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationMessagesApi - interface
 * @export
 * @interface NotificationMessagesApi
 */
export interface NotificationMessagesApiInterface {
    /**
     * 
     * @summary Count new notification messages
     * @param {CountNewNotificationMessagesCategoryEnum} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationMessagesApiInterface
     */
    countNewNotificationMessages(category: CountNewNotificationMessagesCategoryEnum, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCountNewNotifications>;

    /**
     * 
     * @summary get all notification about messages
     * @param {MessagesNotificationCategoryEnum} category 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationMessagesApiInterface
     */
    messagesNotification(category: MessagesNotificationCategoryEnum, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Notification>>;

}

/**
 * NotificationMessagesApi - object-oriented interface
 * @export
 * @class NotificationMessagesApi
 * @extends {BaseAPI}
 */
export class NotificationMessagesApi extends BaseAPI implements NotificationMessagesApiInterface {
    /**
     * 
     * @summary Count new notification messages
     * @param {CountNewNotificationMessagesCategoryEnum} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationMessagesApi
     */
    public countNewNotificationMessages(category: CountNewNotificationMessagesCategoryEnum, options?: RawAxiosRequestConfig) {
        return NotificationMessagesApiFp(this.configuration).countNewNotificationMessages(category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all notification about messages
     * @param {MessagesNotificationCategoryEnum} category 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationMessagesApi
     */
    public messagesNotification(category: MessagesNotificationCategoryEnum, filter?: string, options?: RawAxiosRequestConfig) {
        return NotificationMessagesApiFp(this.configuration).messagesNotification(category, filter, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CountNewNotificationMessagesCategoryEnum = {
    Admin: 'admin',
    Caf: 'caf',
    Citizen: 'citizen'
} as const;
export type CountNewNotificationMessagesCategoryEnum = typeof CountNewNotificationMessagesCategoryEnum[keyof typeof CountNewNotificationMessagesCategoryEnum];
/**
 * @export
 */
export const MessagesNotificationCategoryEnum = {
    Admin: 'admin',
    Caf: 'caf',
    Citizen: 'citizen'
} as const;
export type MessagesNotificationCategoryEnum = typeof MessagesNotificationCategoryEnum[keyof typeof MessagesNotificationCategoryEnum];
